import type { Pagination as PaginationType } from 'commons/modules/pagination';
import type { ConfigurationType } from './types';

export const defaultConfiguration: ConfigurationType = {
  tableName: '',
  typeOfTable: '',
  configVersion: 0,
  showTableHeader: false,
  showConfigurationColumn: false,
  showConfigurationSize: false,
  showConfigurationFullscreen: false,
  showConfigurationRefresh: false,
  showColumnsDefault: false,
};

export const defaultPagination: PaginationType = {
  page: 0,
  pageSize: 0,
  count: 0,
};
